<template>
  <div class="commandAndDispatch" v-loading="pageLoading">
    <el-popover
      ref="productPopover"
      popper-class="product-matrix-popper"
      placement="bottom"
      :visible-arrow="false"
      width="456"
      trigger="hover">
        <div class="product-matrix-box">
          <img src="~@/assets/img/box_bg.svg" class="product-img" alt="">
          <div class="product-head">中关村街道关芯AI智能政务服务系统</div>
          <div class="product-content">
            <div class="product-item" @click="openProduct(product)" 
              v-for="product in productList" :class="product.disable ? 'product-item-disable':''" :key="product.id">
              <img class="product-ico" :src="product.ico" alt="">
              <div class="product-name">{{ product.name }}</div>
            </div>
          </div>
        </div>
        <div slot="reference" class="jump_houtai">
          <img src="~@/assets/img/select_ico.svg" alt="" style="width: 16px; height: 16px;">
          <div>产品生态</div>
        </div>
    </el-popover>
    
    <div class="top_right">
      <div class="time-box">
        <span>{{ currentTime }}</span>
        <!-- <span>{{ currentHour }}</span> -->
        <span>{{ currentWeek }}</span>
      </div>
    </div>
    <div v-if="!pageLoading" class="content">
      <left></left>
      <centerItem></centerItem>
      <right></right>
    </div>
  </div>
</template>

<script>
import CryptoJS from "crypto-js";
import { getPermission } from "@/api/sso";
import left from "./components/left/index.vue";
import centerItem from "./components/centerItem/index.vue";
import right from "./components/right/index.vue";
import ico1 from '../../assets/img/box_ico_1.svg'
import ico2 from '../../assets/img/box_ico_2.svg'
import ico3 from '../../assets/img/box_ico_3.svg'
import ico4 from '../../assets/img/box_ico_4.svg'
import ico5 from '../../assets/img/box_ico_5.svg'
import ico6 from '../../assets/img/box_ico_6.svg'
export default {
  name: "index",
  components: {
    left,
    centerItem,
    right,
  },
  data() {
    return {
      token: null,
      zxCode: null,
      pageLoading: true,
      currentTime: "",
      currentHour: "",
      currentWeek: "",
      isSzzlPt: false,
      productList: [
        { id: 1, name: '关芯客服问答\n（PC端）', ico: ico1, testUrl: 'https://dibrain.wenge.com/wg-agent-client-zgc-gov/#/knowledgeDetails/zgc', prodUrl: 'https://gxai.bjhddsj.cn/wg-agent-client/#/knowledgeDetails/zgc' },
        { id: 2, name: '关芯助理问答\n（PC端）', ico: ico2, testUrl: 'https://dibrain.wenge.com/wg-agent-client-zgc-gov/#/knowledgeDetails/zgc-law', prodUrl: 'https://gxai.bjhddsj.cn/wg-agent-client/#/knowledgeDetails/zgc-law' },
        { id: 3, name: '关芯客服/助理\n后台管理', ico: ico3, testUrl: 'https://dibrain.wenge.com/wg-agent-manage-zgc-gov/#/login', prodUrl: 'https://gxai.bjhddsj.cn/wg-agent-manage/#/login' },
        { id: 4, name: '关芯智巡后台管理', ico: ico4, url: '' },
        { id: 5, name: '关芯智巡可视化平台\n（小）', ico: ico5, url: 'patrolScreen' },
        { id: 6, name: '关芯智巡可视化平台\n（大）', ico: ico6, url: 'patrolLargeScreen', disable: true }
      ]
    };
  },
  created() {
    this.pageLoading = false
    if (this.$route.query.zxCode) {
      this.pageLoading = true
      setTimeout(()=>{
        this.pageLoading = false
        this.token = sessionStorage.getItem("access_token")
        this.zxCode = sessionStorage.getItem("zc_code")
        this.getUserShow();
      }, 500)
    }
  },
  mounted() {
    this.zxCode = sessionStorage.getItem("zc_code")
    this.isSzzlPt = this.$route.query.szzlpt;
    setInterval(() => {
      this.currentTime = this.getCurrentTime();
      this.currentHour = this.getCurrentHour();
      this.currentWeek = this.getCurrentWeek();
    }, 1000);
  },
  methods: {
    // 获取菜单权限和用户信息
    async getUserShow() {
      let params = {
        accessToken: `Bearer ${this.token}`
      };
      const res = await getPermission(params);

      if (res.data.code == 200 && res.data.data && res.data.data.length) {
        let menuList = [];
        res.data.data.map(item => {
          if (item.data.menuCode == "auth-menu") {
            this.list = item.children;
            menuList = JSON.parse(JSON.stringify(item.children));
          }
        });
        if (menuList.length) {
          let curList =
            menuList.find(item => item.children && item.children.length) || [];
          this.id = curList.id;
          this.initMenu(curList.children);
          sessionStorage.setItem(
            "menuChildren",
            JSON.stringify(curList.children)
          );
        }
      }
    },
    initMenu(array) {
      this.curList = array;
      if (this.curList.length) {
        if (this.curList[0].children && this.curList[0].children.length)
          this.desbel = this.curList[0].children[0].data.menuUrl;
        else this.desbel = this.curList[0].data.menuUrl;

        if (sessionStorage.getItem("curDefaultActive")) {
          this.defaultActive = sessionStorage.getItem("curDefaultActive");
        } else {
          this.defaultActive = this.desbel;
          sessionStorage.setItem("curDefaultActive", this.desbel);
        }
      }
    },
    openProduct(product) {
      if (product.id === 6) {
        return false;
      }
      const openWindow = () => {
        if (product.id > 3) {
          // 本系统
          if (product.id === 4) {
            // 不用处理 - 跳转到当前系统后台
            this.jump()
          } else if (product.url) {
            const routeUrl = this.$router.resolve({ path: '/' + product.url })
            window.open(routeUrl.href, '_blank')
          }
        } else {
          // 外部系统 - 使用新窗口打开 prodUrl
          if (process.env.NODE_ENV == 'production') {
            if (product.prodUrl) {
              window.open(product.prodUrl+'?zxCode='+encodeURIComponent(this.encryptByAES(this.zxCode)), '_blank')
            }
          } else {
            if (product.testUrl) {
              window.open(product.testUrl+'?zxCode='+encodeURIComponent(this.encryptByAES(this.zxCode)), '_blank')
            }
          }
        }
      }
      const popper = document.querySelector('.product-matrix-popper');
      if (popper) {
        popper.style.display = 'none';
      }
      this.$refs.productPopover.showPopper = false;
      this.$nextTick(() => requestAnimationFrame(openWindow));
    },
    encryptByAES (message) {
        message = message.toString();
        var key = 'u9dYuYlGVk39kkb5';
        var iv = 'LT0cYheDsyKGHENw';
        var keyHex = CryptoJS.enc.Utf8.parse(key);
        var ivHex = CryptoJS.enc.Utf8.parse(iv);
        var encrypted = CryptoJS.AES.encrypt(message, keyHex, {
          iv: ivHex,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.toString();
    },
    jump() {
      let path = sessionStorage.getItem("curDefaultActive");
      this.$router.push({
        path: path,
      });
    },
    getCurrentTime() {
      let year = new Date().getFullYear();
      let month = ("0" + (new Date().getMonth() + 1)).slice(-2); // JavaScript中月份从0开始计算，所以需要加上1
      let date = ("0" + new Date().getDate()).slice(-2);
      return year + "-" + month + "-" + date;
    },
    getCurrentHour() {
      let hours = ("0" + new Date().getHours()).slice(-2);
      let minutes = ("0" + new Date().getMinutes()).slice(-2); // JavaScript中月份从0开始计算，所以需要加上1
      let seconds = ("0" + new Date().getSeconds()).slice(-2);
      return hours + ":" + minutes + ":" + seconds;
    },
    getCurrentWeek() {
      const date = new Date(); // 创建一个新的Date对象表示当前时间
      let week;
      switch (date.getDay()) {
        case 0:
          week = "星期日";
          break;
        case 1:
          week = "星期一";
          break;
        case 2:
          week = "星期二";
          break;
        case 3:
          week = "星期三";
          break;
        case 4:
          week = "星期四";
          break;
        case 5:
          week = "星期五";
          break;
        default:
          week = "星期六";
          break;
      }

      return week;
    },
  },
};
</script>

<style scoped lang="less">
.commandAndDispatch {
  cursor: pointer;
  width: 2560px;
  height: 1440px;
  overflow: auto;
  background: url("~@/assets/daping/bg-mini.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .jump_houtai {
    position: absolute;
    top: 55px;
    left: 24px;
    width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: url("~@/assets/image/guanlihoutai.png") no-repeat;
    background-size: 100% 100%;
    font-weight: 500;
    font-size: 14px;
    color: #00d1fe;
    margin-right: 30px;
    div {
      // margin-top: 3px;
      margin-left: 5px;
    }
  }
  .content {
    width: 100%;
    height: calc(100% - 122px);
    display: flex;
    margin-top: 122px;
    padding: 0 24px;
  }
  .top_right {
    position: absolute;
    right: 32px;
    top: 65px;
    display: flex;
    align-items: center;
    .time-box {
      span {
        margin-right: 24px;
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 24px;
        color: #f3f8ff;
        line-height: 32px;
        letter-spacing: 4px;
        text-align: center;
        font-style: normal;
        background: linear-gradient(180deg, #5bacef 0%, #ffffff 100%);
        color: transparent;
        /* 使用背景渐变填充文字 */
        -webkit-background-clip: text;
        background-clip: text;
        text-shadow: 0px 5px 10px rgba(3, 9, 24, 0.2);
      }
      span:first-child {
        margin-right: 12px;
      }
      span:last-child {
        margin-right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/index.vue